// src/data/visaData.js
const visaData = [
  {
    id: "india-ev",
    visa: "India E-Visa",
    description: "Apply for India E-Visa quickly and easily with our streamlined process.",
    image: "/visa/india.jpg",
    details: "Our India E-Visa process is designed to be fast, secure, and user-friendly. Typically, it allows a stay of up to 60 days for tourism with a processing time of 3-5 business days. Enjoy a hassle-free application experience with expert guidance at every step."
  },
  {
    id: "india-regular",
    visa: "India Regular Visa",
    description: "Seamless processing for your India Regular Visa application.",
    image: "/visa/indiaa.jpg",
    details: "For traditional sticker or paper visas, our comprehensive service ensures that every requirement is met. The stay duration may extend up to 180 days, and processing times generally range between 7-10 business days, depending on your individual circumstances."
  },
  {
    id: "us",
    visa: "US Visa",
    description: "Expert guidance for obtaining your US Visa.",
    image: "/visa/usa.jpg",
    details: "Navigating the US Visa process can be complex. Our experienced consultants provide step-by-step support. Processing times typically range from 2-4 weeks, and the visa validity depends on the type of visa you apply for."
  },
  {
    id: "uk",
    visa: "UK Visa",
    description: "Navigate UK Visa procedures with our professional support.",
    image: "/visa/uk.jpg",
    details: "Our UK Visa service is tailored to meet your needs. Processing usually takes 15-30 days, and the permitted stay depends on the visa type. We assist you in compiling all necessary documentation for a smooth application process."
  },
  {
    id: "schengen",
    visa: "Schengen Visa",
    description: "Your gateway to Europe with a hassle-free Schengen Visa process.",
    image: "/visa/sc.jpg",
    details: "A Schengen Tourist Visa typically allows a stay of up to 90 days within a 180-day period. The processing time is usually around 15 calendar days. We ensure that your application meets all requirements for travel across multiple European countries."
  },
  {
    id: "uae",
    visa: "UAE Visa",
    description: "Smooth and reliable UAE Visa processing for your travel needs.",
    image: "/visa/uae.webp",
    details: "Our UAE Visa service is designed to meet both business and tourism needs. A UAE Tourist Visa typically permits a stay of up to 30 days with a processing time of 3-7 business days. We provide expert assistance to expedite your application."
  },
  {
    id: "japan",
    visa: "Japan Visa",
    description: "Begin your journey to Japan with our expert visa assistance.",
    image: "/visa/japan.jpg",
    details: "Our Japan Visa service provides comprehensive support from application submission to final approval. Processing time is generally around 5-7 business days, and the visa typically allows a stay for tourism of up to 90 days."
  },
  {
    id: "hongkong",
    visa: "Hongkong Visa",
    description: "Fast and efficient Hongkong Visa processing.",
    image: "/visa/hongkong.webp",
    details: "Our dedicated Hongkong Visa service offers expert guidance with a processing time usually between 3-5 business days. The permitted stay depends on the specific visa category."
  },
  {
    id: "cambodia",
    visa: "Cambodia Visa",
    description: "Reliable service for your Cambodia Visa application.",
    image: "/visa/cambodia.jpg",
    details: "Our Cambodia Visa service streamlines your application process. Processing typically takes 3-7 business days, and the visa validity depends on your travel requirements and documentation."
  },
  {
    id: "vietnam",
    visa: "Vietnam Visa",
    description: "Simplified process for obtaining a Vietnam Visa.",
    image: "/visa/vietnam.jpg",
    details: "We offer a simplified process for Vietnam Visa applications, with processing times typically ranging from 3-5 business days. The visa permits a stay for tourism as per the specific guidelines issued by the authorities."
  }
];

export default visaData;
